import React from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <style>{`
                body {
                    background-color: #121212;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                }

                .legal-container {
                    background-color: #1f1f1f;
                    padding: 2rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                    max-width: 900px;
                    margin: 2rem auto;
                    color: #a5a6ad;
                    font-size: 0.95rem;
                    line-height: 1.6;
                }
                
                .legal-container h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #ffffff;
                    border-bottom: 2px solid #333;
                    padding-bottom: 0.75rem;
                    margin-bottom: 2rem;
                }
                
                .legal-container h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #f0f0f0;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                }
                
                .legal-container p {
                    margin-bottom: 1.2rem;
                    color: #b0b0b0;
                }
                
                .legal-container ul {
                    list-style-type: none;
                    padding-left: 0;
                    margin-bottom: 1rem;
                }
                
                .legal-container li {
                    position: relative;
                    padding-left: 1.5rem;
                    margin-bottom: 0.75rem;
                    color: #b0b0b0;
                }
                
                .legal-container li::before {
                    content: '•';
                    color: #4a90e2;
                    position: absolute;
                    left: 0;
                    font-size: 1.2rem;
                    line-height: 1;
                }
                
                .legal-container strong {
                    color: #ffffff;
                    font-weight: 600;
                }
                
                .legal-container .highlight {
                    background-color: #2a2a31;
                    padding: 1.5rem;
                    border-radius: 0.5rem;
                    border-left: 4px solid #4a90e2;
                    margin: 2rem 0;
                }
                
                .legal-container .highlight p {
                    color: #d0d0d0;
                    margin: 0;
                }

                .company-name {
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #9e9e9e;
                    margin-bottom: 0.5rem;
                    display: block;
                }
            `}</style>
            <div className="legal-container">
                <span className="company-name">CommunityofHubs</span>
                <h2>Privacy Policy</h2>
                <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>

                <h3>1. Information We Collect</h3>
                <p>
                    We collect your name, email, and quiz responses to allow you to use the platform effectively. When you create an account with us, you must provide information that is accurate, complete, and current at all times.
                </p>

                <h3>2. Payment Information</h3>
                <p>
                    If you purchase a certificate, payment is processed securely via Razorpay. We never store your card or UPI information. All payment transactions are encrypted and processed through secure payment gateways.
                </p>

                <h3>3. How We Use Your Information</h3>
                <p>
                    Your data is used to generate certificates, process payments, and send updates about your quiz results. We use your information to provide, maintain, and improve our services, and to communicate with you about your account.
                </p>

                <h3>4. Data Sharing</h3>
                <p>
                    We do not sell or rent your personal data to third parties. We may share your information with service providers who assist us in operating our platform, conducting our business, or servicing you, as long as those parties agree to keep this information confidential.
                </p>

                <h3>5. Data Security</h3>
                <div className="highlight">
                    <p>
                        We use standard security measures to protect your data, but please keep your password safe. We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                    </p>
                </div>

                <h3>6. Your Rights</h3>
                <p>
                    You may request to update or delete your data at any time via the Contact Us page. You have the right to access, correct, or delete your personal information, and you may also object to or restrict certain processing of your data.
                </p>

                <h3>7. Updates to This Policy</h3>
                <p>
                    By using this website, you agree to this Privacy Policy and any updates we may make in the future. We may update this Privacy Policy from time to time, and we will notify you of any changes by posting the new policy on this page.
                </p>

                <h3>8. Contact Us</h3>
                <p>If you have questions about this Privacy Policy, please contact us at: privacy@communityofhubs.com</p>
            </div>
        </>
    );
};

export default PrivacyPolicy;